import { render, staticRenderFns } from "./mcs_light_female_trap_data.vue?vue&type=template&id=83bcc378&"
import script from "./mcs_light_female_trap_data.vue?vue&type=script&lang=js&"
export * from "./mcs_light_female_trap_data.vue?vue&type=script&lang=js&"
import style0 from "./mcs_light_female_trap_data.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports